<template>
  <v-data-table class="elevation-1 table" :headers="computedHeader" :items="data" :pagination.sync="pagination" hide-actions>
    <template slot="headers" slot-scope="props">
      <tr>
        <th>
        <td :input-value="props.all" :indeterminate="props.indeterminate" primary hide-details></td>
        </th>
        <th v-for="header in props.headers" :key="header.text" @click="changeSort(header.value)">
          {{ header.text }}
          <v-icon small v-show="pagination.sortBy != header.text" color="primaryText">arrow_upward</v-icon>
          <v-icon small v-show="pagination.sortBy == header.text && pagination.descending == false" color="primaryText">arrow_upward</v-icon>
          <v-icon small v-show="pagination.sortBy == header.text && pagination.descending == true" color="primaryText">arrow_downward</v-icon>
        </th>
      </tr>
    </template>
    <template slot="items" slot-scope="props">
      <tr>
        <td>
          <v-checkbox v-model="inverterState[simpleString(props.item.Equipment)]" primary hide-details></v-checkbox>
        </td>
        <td v-for="(items,key,index) in props.item" v-show="index >= 1" :class="text-xs-center"
          :key="index">
          <span :class="key != 'Equipment' ? dataCondition(props.item.id, index, items) == 'No Data' ? 'error--text' : 'number--text' : ''">
            {{ dataCondition(props.item.id, index, items) == 'No Data' ? $t('No Data') : dataCondition(props.item.id, index, items) }}
          </span>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import _ from "lodash";
import service from "@/services/Scb.js";
import service1 from "@/services/zone-monitoring.js";
import { mixin, mapGettersMixin, miscellaneous } from "@/util/mixin/index.js";
import { mapMutations } from "vuex";

export default {
  mixins: [mixin, mapGettersMixin, miscellaneous],
  props: ["plantId", "dataView", "date", "chips"],
  data() {
    return {
      data: [],
      headers: [],
      ncdata: [],
      channels: [],
      localChips: [],
      inverterState: {},
      graphParameters: new Set(),
      channelCount: null,
      channelWithId: {},
      enableInverterStateWatch: false,
      pagination: {
        sortBy: 'Equipment',
        rowsPerPage: 500
      }
    };
  },
  computed: {
    dateAndDataView() {
      return `${this.date} ${this.dataView}`;
    },
    computedHeader() {
      return this.headers.map((el) => {
        const obj = _.cloneDeep(el);
        if (el.text.includes("Ch")) {
          return obj;
        }

        obj["text"] = this.$t(el.text);
        return obj;
      });
    },
  },
  async created() {
    await this.setIntervalWithoutDelay(this.getTableData);
  },
  methods: {
    ...mapMutations(["SET_PROGRESS_BAR"]),
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    dataCondition(id, index, items) {
      if (this.ncdata[id] && this.ncdata[id].indexOf(`${index - 4}`) !== -1) {
        return "NC";
      } else if (index > 1) {
        if (items == null) {
          return "No Data";
        } else {
          return parseFloat(items).toFixed(2);
        }
      }
      return items;
    },
    async getTableData() {
      try {
        this.SET_PROGRESS_BAR(true);
        let response = await service.getAdvancedStingInverterData(
          this.plantId,
          this.dataView,
          this.date
        );
        let count = await service1.getStringCount(this.plantId);
        this.SET_PROGRESS_BAR(false);
        this.data = response.data.message.data;
        this.data.forEach((el) => {
          let key = this.simpleString(el.Equipment);
          this.$set(this.inverterState, key, false);
        });
        this.ncdata = count.data.message;
        this.headers = response.data.message.headers;
        this.graphParameters = new Set(response.data.message.graphParameters);
        this.$emit("availableData", this.graphParameters);
        this.channelCount = response.data.message.channelCount;
        this.enableInverterStateWatch = true;
      } catch (err) {
        this.SET_PROGRESS_BAR(false);
      }
    },
    inverterSelected(key) {
      key = this.simpleString(key);
      this.channels = [];
      const originalObject = {};
      originalObject[key] = this.data.filter(
        (d) => this.simpleString(d.Equipment) == key
      )[0];

      const { id } = originalObject[key];

      if (this.inverterState[key]) {
        // When checkbox is checked
        for (let i = 0; i < this.channelCount; i++) {
          this.channels.push(i + 1);
        }

        if (this.ncdata[id] !== undefined) {
          Object.entries(this.ncdata[id]).forEach(([key, value]) => {
            if (this.channels.includes(value) === false) {
              let key = this.channels.indexOf(parseInt(value));
              this.channels.splice(key, 1);
            }
          });
        }

        this.channels
          .filter((val) => !this.localChips.includes(id.concat("-ch-", val)))
          .forEach((el) => {
            this.localChips.push(id.concat("-ch-", el));
          });

        this.channelWithId[id] = this.channels;
      } else {
        // When checkbox is unchecked
        for (let i = 1; i <= this.channelCount; i++) {
          let localKey = this.localChips.indexOf(id.concat("-ch-", i));
          this.channels.push(i);
          if (localKey > -1) {
            this.localChips.splice(localKey, 1);
            this.localChips = [...this.localChips];
          }
        }
        delete this.channelWithId[id];
      }
    },
  },
  watch: {
    isReload() {
      if (this.isReload) {
        this.setIntervalWithoutDelay(this.callAllApi);
      }
    },
    data() {
      this.data.forEach((item) => {
        if (this.enableInverterStateWatch) {
          this.$watch(
            "inverterState." + this.simpleString(item.Equipment),
            function () {
              this.inverterSelected(item.Equipment);
            }
          );
        }
      });
    },
    dateAndDataView() {
      this.getTableData();
    },
    localChips() {
      this.$emit("chipsUpdate", {
        chips: this.localChips,
        chipsObj: this.channelWithId,
      });
    },
    chips() {
      const removeLast2String = (arr) => {
        let chip = arr.map((el) => {
          return el.split("-ch-")[0];
        });
        const uniqueChip = [...new Set(chip)];
        return uniqueChip;
      };

      const currentChip = removeLast2String(this.chips);
      const oldChip = removeLast2String(this.localChips);
      if (!this.isArrEqual(currentChip, oldChip)) {
        const unCheckedCheckbox = this.arrDifference(oldChip, currentChip)[0];
        const inverterStateKey = this.data.filter(
          (el) => el.id === unCheckedCheckbox
        )[0];
        this.inverterState[
          this.simpleString(inverterStateKey.Equipment)
        ] = false;
      }
    },
  },
};
</script>

<style scoped>
.table {
  height: calc(100vh - 305px);
  overflow: auto;
  display: flex;
}

.table th {
  z-index: 1;
  position: sticky;
  top: 0;
  color: var(--v-extraGrey) !important;
  background: var(--v-primary-base) !important;
}
</style>

<style>
.table .v-table__overflow {
  overflow: auto;
}
</style>